<template>
  <v-btn outlined color="primary" @click="exportExcel">Xuất excel</v-btn>
</template>
<script>
import { get } from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'
import utils from '@/plugins/utils'

const excelHeader = [
  { text: 'Học sinh', value: 'student' },
  { text: 'Mã học sinh', value: 'code' },
  { text: 'Ngày sinh', value: 'dob' },
  { text: 'Lớp', value: 'currentClass' },
  { text: 'Ngày học', value: 'date' },
  { text: 'Trạng thái', value: 'present' },
  { text: 'CP/KP/Đi muộn', value: 'status' }
]

export default {
  props: {
    params: Object
  },
  methods: {
    ...mapActions('Diligence', ['getStudentDiligencesExcel']),
    async exportExcel() {
      this.$loading.active = true
      try {
        const data = await this.getStudentDiligencesExcel({ ...this.params, _limit: -1 })

        if (Array.isArray(data) && data.length) {
          const dataConvert = data.map(d => ({
            student: get(d, 'student.name', ''),
            code: get(d, 'student.code_short', ''),
            dob: moment(get(d, 'student.dob', '')).format('DD/MM/YYYY'),
            currentClass: get(d, 'class.title', ''),
            date: moment(d.date).format('DD/MM/YYYY'),
            present: d.present ? 'Có mặt' : 'Vắng mặt',
            status: this.$options.filters.getDiligenceStatus(d.status)
          }))

          utils.exportExcel(
            dataConvert,
            excelHeader,
            `Thống kê chuyên cần từ ${moment(this.params.date_gte).format('YYMMDD')} đến ${moment(
              this.params.date_lte
            ).format('YYMMDD')}`
          )
        } else this.$alert.error('Không có dữ liệu để xuất excel')
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
